<div class="delivery-provider-dialog">
  <div class="delivery-provider-dialog__header">
    <span class="delivery-provider-dialog__header__timer">
      {{ formattedTime }}
    </span>
    <h3 class="delivery-provider-dialog__header__subtitle">
      {{ 'common.deliveryProviderDialog.subtitle' | translate }}
    </h3>
    <h2 class="delivery-provider-dialog__header__title">
      {{ 'common.deliveryProviderDialog.title' | translate }}
    </h2>
  </div>

  <div class="delivery-provider-dialog__footer">
    <button
      class="delivery-provider-dialog__footer__button delivery-provider-dialog__footer__cancel"
      (click)="cancel()"
    >
      {{ 'common.deliveryProviderDialog.cancel' | translate }}
    </button>
    <button
      class="delivery-provider-dialog__footer__button delivery-provider-dialog__footer__select"
      (click)="selectProvider()"
    >
      {{ 'common.deliveryProviderDialog.selectProvider' | translate }}
    </button>
    <button
      class="delivery-provider-dialog__footer__button delivery-provider-dialog__footer__skip"
      (click)="skip()"
    >
      {{ 'common.deliveryProviderDialog.skip' | translate }}
    </button>
  </div>
</div>
